export default "__VITE_ASSET__BRr7yPBX__"